export default __webpack_public_path__ + "static/media/roughness.b090930d.svg";